import React, { useEffect } from 'react';
import Layout from '@components/layout';
import SEO from '@components/seo';
import SimpleFooter from '@components/simple-footer/simple-footer';
import { COOKIES } from '@constants/cookies';
import { removeCookie } from '@services/cookies';
import { getShopifyHost } from '@src/utils/shopify-host-redirect';
import styles from './redirect-error.module.scss';

const RedirectErrorPage: React.FC = () => {
  useEffect(() => {
    removeCookie(COOKIES.token);
    removeCookie(COOKIES.guestToken);
    removeCookie(COOKIES.basketId);
  }, []);

  const shopifyHomeUrl = getShopifyHost() || '/';

  return (
    <Layout showFooter={false}>
      <SEO title="Redirect issue" description="Something went wrong while redirecting you." />
      <section className={styles.wrapper}>
        <div className={styles.card}>
          <p className={styles.eyebrow}>Technical issue</p>
          <h1 className={styles.title}>Uh oh, something went wrong</h1>
          <p className={styles.description}>
            We discovered a repeated redirect and prevented itto protect your browser session. Please return to the Vitl homepage and
            try again from there.
          </p>
          <a className={styles.button} href={shopifyHomeUrl}>
            Go to Vitl homepage
          </a>
        </div>
      </section>
      <SimpleFooter />
    </Layout>
  );
};

export default RedirectErrorPage;
